module.exports = __webpack_public_path__ + "img/2_243.f239117d.png";